export default __webpack_public_path__ + "static/contact-937bc58c24d49592abab9038f793d495.jpg";